import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Divider, Text } from '@chakra-ui/react'
import React from 'react'
import WorkExperienceTitle from './WorkExperienceTitle'
import NotAvailable from '../NotAvailable'
import SubTitle from '../SubTitle'
import { workExpIcon } from '../Icons'

const WorkExperience = ({ WorkExperience }) => {
    return (
        <>
            <SubTitle title="Work Experience" titleIcon={workExpIcon} />
            {
                WorkExperience.length === 0 ? <NotAvailable /> :
                    WorkExperience.map((workExp, index) =>
                        <WorkExperienceTitle key={index} workExp={workExp} />
                    )
            }
        </>
    )
}

export default WorkExperience